<script>
import IconSearch from "../../../assets/icons/ic-search.svg";
import IconFiltre from "../../../assets/icons/ic-filtre.svg";
import radio from "../../helper/form/radio.vue";
import icKa from "../../../assets/icons/ic-ka.svg";
import Tel from "../../../assets/icons/ic-telephone.svg";
import { getAccountant, sendInvitationAccountant } from "@/component/cdevs/allFunctions";
import CharteredLists from "@/component/cdevs/charteredAccountants/CharteredLists.vue";
import prev from "../../../assets/icons/prev.svg";
import next from "../../../assets/icons/next.svg";

export default {
  name: "AllCharteredAccountant",
  components: { CharteredLists, radio },
  emits: ["openDetails"],
  data() {
    return {
      icons: { IconSearch, IconFiltre, icKa, Tel, prev, next },
      all_accountant: [],
      charge: false,
      empty: false,
      limit: 20,
      page: 1,
      total: 0,
      totalPage: 1,
      search: "",
      timer: null,
    };
  },

  created() {
    this.getAllChartered(this.limit, this.page);
  },

  methods: {
    cleanObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    },

    /* Function to get all chartered accountant */
    async getAllChartered(limit, page, search) {
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        limit: limit,
        page: page,
        search: search,
        type: "CERTIFIED_ACCOUNTANT",
      };
      this.cleanObject(data);

      try {
        const response = await getAccountant(data);
        // response peut contenir différentes formes, gérer les cas courants
        // priorité: response.data (liste), response.meta.total, response.total, response.count
        // on extrait la liste
        const list = response.data && Array.isArray(response.data) ? response.data : (response.data && response.data.items) || response.data || [];
        this.all_accountant = list;

        // extraire total d'éléments si disponible
        const totalFromMeta = response.meta && (response.meta.total || response.meta.count || response.meta.totalItems || response.meta.total_count);
        const totalFromData = response.total || response.count || (response.data && (response.data.total || response.data.count));

        this.total = Number(totalFromMeta || totalFromData || (Array.isArray(list) ? list.length : 0));

        // calcul totalPage
        this.totalPage = this.limit > 0 ? Math.max(1, Math.ceil(this.total / this.limit)) : 1;

        this.charge = false;
      } catch (error) {
        console.error(error);
        this.charge = false;
        this.$toast.error("Une erreur est survenue");
      }
    },

    // Aller à la page précédente
    prevPage() {
      if (this.page > 1) {
        this.page -= 1;
        this.getAllChartered(this.limit, this.page, this.search);
      }
    },

    // Aller à la page suivante
    nextPage() {
      if (this.page < this.totalPage) {
        this.page += 1;
        this.getAllChartered(this.limit, this.page, this.search);
      }
    },

    // Aller à une page spécifique
    goToPage(p) {
      const pageNumber = Number(p) || 1;
      if (pageNumber >= 1 && pageNumber <= this.totalPage) {
        this.page = pageNumber;
        this.getAllChartered(this.limit, this.page, this.search);
      }
    },

    openDetails(item) {
      this.$emit("openDetails", item);
    },

    // Fonction pour envoyer l'invitation
    async sendInvitation(item) {
      console.log('📨 Début de l\'envoi de l\'invitation');
      console.log('👤 Item reçu:', item);
      
      try {
        const data = {
          apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
          accountantId: item.id || item._id,
          email: item.email,
          firstName: item.firstName,
          lastName: item.lastName,
        };
        
        console.log('Data à envoyer:', data);
        
        const response = await sendInvitationAccountant(data);
        
        console.log('✅ Réponse de l\'API:', response);
        
        this.$toast.success(`Invitation envoyée avec succès à ${item.firstName} ${item.lastName}`);
        
      } catch (error) {
        console.error('Erreur lors de l\'envoi de l\'invitation:', error);
        console.error('Détails de l\'erreur:', error.response?.data || error.message);
        
        this.$toast.error(`Erreur lors de l'envoi de l'invitation à ${item.firstName} ${item.lastName}`);
      }
    },
  },

  watch: {
    search(newValue) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        // reset to first page when searching
        this.page = 1;
        this.getAllChartered(this.limit, this.page, newValue);
      }, 300);
    },
  },
};
</script>

<template>
  <div class="bg-white w-full rounded-10 p-5">
    <div class="flex justify-start responsive-container">
      <div class="flex items-center justify-start gap-5">
        <div
          class="w-2/3 flex items-center justify-start border border-gray py-2 rounded-100"
        >
          <icon
            :data="icons.IconSearch"
            height="26"
            width="26"
            class="w-5 h-5 mx-4"
            original
          />
          <input
            v-model="search"
            type="text"
            class="text-c16 responsive-input"
            placeholder="Rechercher"
          >
        </div>
        <div
          class="border border-gray p-2 flex items-center rounded-100 gap-2 cursor-pointer responsive-filter"
        >
          <icon
            :data="icons.IconFiltre"
            height="26"
            width="26"
            class="w-5 h-5"
            original
          />
          Filtre
          <div class="bg-red text-white rounded-100 px-2">
            1
          </div>
        </div>
      </div>
    </div>

    <div class="responsive-container">
      <div
        class="BGGRAY w-full flex items-center TextColor h-14 px-5 rounded-t-10 mt-5"
      >
        <div class="flex items-center gap-5 w-1/2">
          <radio />
          <div>Comptable</div>
        </div>
        <div class="w-1/3">
          Cabinet
        </div>
        <div class="w-1/2">
          Email
        </div>
        <div class="w-1/3">
          Téléphone
        </div>
        <div class="w-80">
          Entp. gérées
        </div>
        <div class="w-80">
          Dernière activité
        </div>
        <div class="w-80">
          Actions
        </div>
      </div>

      <div
        v-if="charge"
        class="flex justify-center mt-16"
      >
        <easy-spinner
          type="dots"
          size="70"
        />
      </div>

      <div
        class="text-center my-10"
        v-if="all_accountant.length === 0 && !charge"
      >
        Aucun expert comptable pour le moment
      </div>

      <div class="w-full">
        <CharteredLists
          v-for="(item, i) in all_accountant"
          :key="i"
          :one-person="item"
          @click="openDetails(item)"
          @sendInvitation="sendInvitation"
        />
      </div>
      <div class="flex mt-10 justify-end pb-10 pr-10">
        <div class="w-1/3 flex items-center justify-end">
          <div class="text-c16 font-c6">
            Page {{ page }} sur {{ totalPage }}
          </div>
          <icon
            :data="icons.prev"
            height="50"
            width="50"
            :class="['icone ml-4', { 'cursor-not-allowed opacity-50': page <= 1, 'cursor-pointer': page > 1 }]"
            original
            @click="prevPage"
          />
          <icon
            :data="icons.next"
            height="50"
            width="50"
            :class="['icone ml-4', { 'cursor-not-allowed opacity-50': page >= totalPage, 'cursor-pointer': page < totalPage }]"
            original
            @click="nextPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.BGGRAY {
  background-color: #eff5f9;
}
.TextColor {
  color: #6b6b75;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
}
.BorderColor {
  border-bottom: 1px solid #e7eef8;
}
.listeStyle {
  font-weight: 400;
  font-size: 18px;
}
.Email {
  color: #6aa3f2;
}
</style>